import React, { useEffect }  from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

import '../../assets/css/client/client.css';
import { CustomColumnDef, FilteringList } from '../../components/filteringList/FilteringList';
import CompanyInfoCard, { CompanyInfo } from '../../components/companyInfo/CompanyInfoCard';
import OutputDatePicker from '../../components/outputDatePicker/OutputDatePicker';
import { Vehicle } from '../../model/Vehicle';
import { useNavigate, useParams, useLocation  } from 'react-router-dom';
import { vehicleTypeToString, roles } from '../../utils/define';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const initialMyCompany: CompanyInfo = {
  infoKind: "",
  companyName: "",
  organization: "",
  address: '',
  phone: '',
  agreement: {
    startDate: '',
    endDate: ''
  },
  staffName: '',
  staffNameKana: '',
  staffPhone: '',
  staffMail: '',
  sysStatus: ''
};

const ClientPage = () => {
  const { authData } = useAuth();
  const navigate = useNavigate();

  // 認証情報がない場合はログインページへリダイレクト
  useEffect(() => {
    if (!authData) {
      navigate('/login');
    }
  }, [authData]);

  const [selectedRows, setSelectedRows] = React.useState({});
  const clientListColumns = React.useMemo<CustomColumnDef<Vehicle>[]>(
    () => [
      {
        accessorFn: row => row.name,
        id: 'name',
        cell: info => info.getValue(),
        header: () => <span>車両名</span>,
      },
      {
        accessorFn: row => row.number,
        id: 'number',
        cell: info => info.getValue(),
        header: () => <span>車両番号</span>,
      },
      {
        accessorFn: row => row.vehicleType,
        id: 'vehicleType',
        cell: info => info.getValue(),
        header: () => <span>車両種別</span>,
      },
    ],
    []
  );

  const location = useLocation();
  const [adminId, setAdminId] = React.useState(
    location.state?.adminId || authData.admin_id
  );
  const [myCompany, setMyCompany] = React.useState(initialMyCompany);
  const [vehicleList, setVehicleList] = React.useState([]);
  const [outputDate, setOutputDate] = React.useState(new Date());
  const { partner_id, client_id } = useParams<{ partner_id: string, client_id: string}>();
  const [sysStatus, setSysStatus] = React.useState(
    location.state?.sysStatus || authData.sys_status
  );
  const [clientListTitle, setClientListTitle] = React.useState(() => {
    if(sysStatus === 0) {
      return "お客様一覧";
    } else {
      return "店舗一覧";
    }
  });
  const [isSysAdmin, setIsSysAdmin] = React.useState(authData.roles.includes(roles.sys_admin));
  const [isClientAdmin, setIsClientAdmin] = React.useState(!isSysAdmin && authData.client_id);

  interface vehicle {
    id: string;
    partner_id: string;
    name: string;
    number: string;
    vehicle_type: string;
  }

  React.useEffect(() => {
    if(partner_id && client_id && adminId){
      axios.get(`${API_BASE_URL}/partners/${partner_id}/clients/${client_id}/vehicles?admin_id=${adminId}`)
      .then(response => {      
        if (response.status === 200) {          
          console.log(`api call success endpoint: ${API_BASE_URL}/partners/${partner_id}/clients/${client_id}/vehicles?admin_id=${adminId}`)
          let list =  response.data.vehicles.map((obj: vehicle) => ({            
            isCheck: false,
            id: obj.id,
            partnerId: obj.partner_id,
            name: obj.name,
            number: obj.number,
            vehicleType: vehicleTypeToString(Number(obj.vehicle_type) - 1).name,
          }));          
          setVehicleList(list);

          setMyCompany({
            infoKind: sysStatus === 0 ? "お客様情報" : "店舗情報",
              companyName: response.data.client.company,
              organization: response.data.client.organization,
              address: response.data.client.address,
              phone: response.data.client.phone_number,
              agreement: {
                startDate: response.data.client.agreement_start_date,
                endDate: response.data.client.agreement_end_date
              },
              staffName: response.data.client.staff_name,
              staffNameKana: response.data.client.staff_name_kana,
              staffPhone: response.data.client.staff_phone_number,
              staffMail: response.data.client.staff_email,
              sysStatus: response.data.client.sys_status,
              vehicleCount:response.data.client.vehicle_count,
          
          });
        } else {
          console.error('get partners failed:', response.data.message || 'Unknown error');
        }
      })
      .catch(error => {
        console.error('Error during login API call:', error);
      });
    }    
  }, [adminId]);

  return (
    <div className="mx-auto my-2" style={{width: "99%"}}>
      {!isClientAdmin && <button type="button" className="btn ps-0 pt-2 pb-2 mb-0 mr-auto fs-6 d-flex align-items-center" onClick={() => navigate(-1)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" className="me-1 bi bi-chevron-left" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
        </svg>
        {clientListTitle}
      </button>}      
      <CompanyInfoCard companyInfo={myCompany} />
      <div className="p-1">
        <h5 className='p-2 mb-0 mr-auto'>車両一覧</h5>
        <OutputDatePicker 
          selectedMonth={outputDate} 
          onChange={(selected) => {
            setOutputDate(selected === null ? outputDate : selected)
          }} 
          onClickDownload={(event) => {
            const year = outputDate.getFullYear();
            const month = outputDate.getMonth() + 1;
            window.open(`/report?year=${year}&month=${month}&cid=${client_id}`, '_blank');
          }}
          className="output-date-picker"
          buttonDisabled={vehicleList.length === 0}
        />
      </div>
      <div style={{display: "flex", justifyContent: "center"}}>
        <FilteringList 
          columns={clientListColumns} 
          datas={vehicleList}
        />
      </div>
    </div>
  );
}

export default ClientPage;